var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      "modal-title": _vm.$t("pages.payroll.sign_title"),
      "show-spinner": _vm.isLoading,
      "show-modal": _vm.showModal,
      "primary-footer-button-translation": _vm.$t("pages.payroll.sign_send"),
      "secondary-footer-button-translation": _vm.$t("pages.payroll.sign_undo"),
      "loading-primary-footer-button": _vm.isLoading,
    },
    on: _vm._d({ shown: _vm.onModalShown, hidden: _vm.onModalHidden }, [
      _vm.primaryEvent,
      _vm.onPrimaryButtonClicked,
      _vm.secondaryEvent,
      _vm.onSecondaryButtonClicked,
      _vm.closeEvent,
      _vm.onCloseButtonClicked,
    ]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "sign-pad-wrap" },
              [
                _vm.padReady
                  ? _c("VueSignaturePad", {
                      ref: "signaturePad",
                      attrs: {
                        id: "signature",
                        width: "100%",
                        height: "220px",
                        options: _vm.options,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }